<template>
  <div class="pagination-box">
    <nav class="ms-auto me-auto" aria-label="...">
      <ul class="pagination pagination-primary">
        <li class="page-item" :class="[{ disabled: currentPage == 1 }]">
          <a class="page-link" href="javascript:void(0)" @click.prevent="changePages(currentPage - 1 > 0 ? currentPage - 1 : changePage)">Previous</a>
        </li>

        <li class="page-item" :class="[{ active: currentPage == page }]" v-for="(page, index) in pages" :key="index">
          <a class="page-link" href="javascript:void(0)" @click.prevent="changePages(page)">{{ page }}</a>
        </li>
        <li class="page-item" :class="[{ disabled: currentPage == totalPages }]">
          <a class="page-link" href="javascript:void(0)" @click.prevent="changePages(currentPage + 1 <= totalPages ? currentPage + 1 : changePage)">Next</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { useFunctionalitiesStore } from '@/store/functionalities';

let props = defineProps({
  allData: {
    type: Array,
    required: true,
  },
});

const functionalitiesStore = useFunctionalitiesStore();
const { changePage } = functionalitiesStore;
const currentPage = ref(1);
const contentToShow = ref(10);
const totalPages = ref(10);
const pages = ref([]);

onMounted(() => {
  totalPages.value = Math.ceil(props.allData.length / contentToShow.value);

  const toSend = {
    toPage: 1,
    totalPages: totalPages.value,
    currentPage: 1,
    allData: props.allData,
  };

  const response = changePage(toSend);
  pages.value = [...response];
});

function changePages(toPage) {
  const toSend = {
    toPage,
    totalPages: totalPages.value,
    currentPage: currentPage.value,
    allData: props.allData,
  };

  if (toPage <= totalPages.value && toPage > 0) currentPage.value = toPage;

  const response = functionalitiesStore.changePage(toSend);
  pages.value = [...response];
  currentPage.value = toPage;
}
</script>

<style></style>
